import { useEffect, useState } from "react";
import { pageViewEvent } from "../services/adobeDataLayer";
import { DataLayerEvent, getValuesInLocalStorange } from "../services/lsq";

function ThankYouRejected() {
  const [executed, setExecuted] = useState(false);
  useEffect(() => {
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you not eligible");
    if (!executed) {
      let pushToDataLayer = async () => {
        const resp = await getValuesInLocalStorange("userData");
        DataLayerEvent(resp?.email, resp?.mobile, "", "", "", "", false);
      };
      pushToDataLayer();
      setExecuted(true);
    }
  }, []);

  return (
    <>
      <article className="thankyou_sec">
        <div className="tick">
          <img
            src="../dist/img/tick.webp"
            alt="tick"
            width="100"
            height="100"
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt">
          <p style={{ width: "60%", marginLeft: "auto", marginRight: "auto" }}>
            Thank you for your interest in ICICI Bank Home Loan.
          </p>

          <p
            className="secondary_txt"
            style={{ width: "60%", marginLeft: "auto", marginRight: "auto" }}
          >
            <br></br>
            Unfortunately, the minimum amount required for online Home Loan
            processing is more than ₹10 lakhs. For lower amount, please visit
            your nearest branch.
          </p>
        </div>
      </article>
    </>
  );
}

export default ThankYouRejected;
